/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u1m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A beginner plank is commonly built up in 20 to 30 second holds, working toward one full minute. If a minute is too hard to hold with good form, break it into two or three shorter holds with brief rests rather than sagging through the full minute.`)
};

const es_timer_u1m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una plancha para principiantes suele desarrollarse con sostenes de 20 a 30 segundos, avanzando hacia un minuto completo. Si un minuto es demasiado difícil de sostener con buena forma, divídelo en dos o tres sostenes más cortos con descansos breves en lugar de hundirte durante todo el minuto.`)
};

const de_timer_u1m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Anfänger-Unterarmstütz wird meist in 20- bis 30-Sekunden-Haltephasen aufgebaut, mit dem Ziel einer vollen Minute. Ist eine Minute mit sauberer Haltung zu schwer, teile sie in zwei oder drei kürzere Haltephasen mit kurzen Pausen, statt die volle Minute durchzuhängen.`)
};

const nl_timer_u1m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een plank voor beginners wordt meestal opgebouwd met holds van 20 tot 30 seconden, toewerkend naar een volledige minuut. Als een minuut te zwaar is om met goede vorm vol te houden, verdeel het dan in twee of drie kortere holds met korte rustpauzes, in plaats van door te zakken tijdens de volledige minuut.`)
};

const fr_timer_u1m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour un débutant, la planche se travaille généralement par tenues de 20 à 30 secondes, en progressant vers une minute complète. Si une minute est trop difficile à tenir avec une bonne posture, découpez-la en deux ou trois tenues plus courtes avec de brefs repos plutôt que de s’affaisser pendant toute la minute.`)
};

const it_timer_u1m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un plank da principiante viene generalmente costruito con tenute di 20-30 secondi, lavorando verso un minuto intero. Se un minuto è troppo difficile da mantenere con una buona forma, dividilo in due o tre tenute più brevi con piccole pause invece di cedere per l'intero minuto.`)
};

const pt_br2_timer_u1m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma prancha para iniciantes normalmente é construída com séries de 20 a 30 segundos, progredindo até um minuto inteiro. Se um minuto for muito difícil de manter com boa forma, divida em duas ou três séries mais curtas com pausas breves em vez de aguentar o minuto inteiro perdendo a postura.`)
};

const pt_timer_u1m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma prancha para principiantes é normalmente construída em posições de 20 a 30 segundos, progredindo até um minuto completo. Se um minuto for demasiado difícil de manter com boa forma, divida-o em duas ou três posições mais curtas com breves descansos, em vez de ceder durante o minuto todo.`)
};

const ja_timer_u1m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初心者のプランクは一般的に20〜30秒の保持から始め、1分間フルに向けて徐々に伸ばしていきます。1分間を良いフォームで保持するのが難しい場合は、フォームを崩して1分間耐えるよりも、短い休憩を挟んで2〜3回に分けて行う方がよいでしょう。`)
};

const zh_timer_u1m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初学者通常从20到30秒的支撑开始逐步增加，最终达到完整一分钟。如果保持标准姿势撑满一分钟太难，可以拆成两到三段较短的支撑并适当休息，而不是塌腰硬撑完整一分钟。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u1m_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u1m_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u1m_faq3_a", locale)
	if (locale === "en") return en_timer_u1m_faq3_a(inputs)
	if (locale === "es") return es_timer_u1m_faq3_a(inputs)
	if (locale === "de") return de_timer_u1m_faq3_a(inputs)
	if (locale === "nl") return nl_timer_u1m_faq3_a(inputs)
	if (locale === "fr") return fr_timer_u1m_faq3_a(inputs)
	if (locale === "it") return it_timer_u1m_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u1m_faq3_a(inputs)
	if (locale === "pt") return pt_timer_u1m_faq3_a(inputs)
	if (locale === "ja") return ja_timer_u1m_faq3_a(inputs)
	return zh_timer_u1m_faq3_a(inputs)
};